<template>
  <li v-on="!isTouch && { mouseenter: toggleSmallCart, mouseleave: toggleSmallCart }">
    <button class="user-actions__link" @click="showCartModal" :aria-label="$t('cart_title')">
      <span class="user-actions__icon">
        <svg width="30" class="user-actions__icon-svg">
          <use :xlink:href="spritePath + '#header_cart'"></use>
        </svg>
      </span>
      <span class="user-actions__label visually-hidden">{{ $t('cart') }}</span>
      <span id="small-cart-counter" class="user-actions__cart-counter" v-if="cartSort.products.length">{{
        cartSort.cart['cartQuantity']
      }}</span>
    </button>
    <header-cart-popup-new :is-popup-visible="isSmallCart"></header-cart-popup-new>
    <!--    <header-cart-popup v-else :is-popup-visible="isSmallCart"></header-cart-popup>-->
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { spritePath } from '@/mixins/spritePath'
import { isTouch } from '@/mixins/isTouchDevice'
// import HeaderCartPopup from '@/components/cart/HeaderCartPopup'
import HeaderCartPopupNew from '@/components/cart/HeaderCartPopupNew'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'HeaderCart',
  mixins: [spritePath, isTouch],
  data () {
    return {
      isSmallCart: false
    }
  },
  components: {
    // HeaderCartPopup,
    HeaderCartPopupNew
  },
  methods: {
    showCartModal () {
      GoogleTagManagerService.btnClickAnalytics({
        event: 'click_cart'
      })
      this.$modal.show(this.cartModalName)
    },
    toggleSmallCart (e) {
      this.isSmallCart = e.type === 'mouseenter'
    }
  },
  computed: {
    ...mapGetters(['cartModalName', 'cartSort'])
  }
}
</script>

<style lang="sass" scoped>
.user-actions__icon-svg
  width: 30px
  height: 25px
</style>
